import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('geometryShapeQuilombolas');

export const check = () => useBasicAuth.checkToken();

export const findAllGeometryShapeQuilombolas = () => 
  axios.get(urlAPI + "/all/" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeQuilombolasInsideByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/inside/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeQuilombolasIntersectsByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/intersects/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeQuilombolasInsideByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/inside/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeQuilombolasIntersectsByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/intersects/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

